require('./bootstrap');

import './common/global';

// IE11対策用
// import 'babel-polyfill';
// ERROR in multi ./resources/js/fullcalendar.js
// Module not found: Error: Can't resolve '/Applications/MAMP/htdocs/emagen/resources/js/fullcalendar.js' in '/Applications/MAMP/htdocs/emagen'
//  @ multi ./resources/js/fullcalendar.js /public/js/fullcalendar[0]

// plugins
// var Chart = require('chart.js');
import './plugins/pagination';
import '@fortawesome/fontawesome-free/js/all.min';
import 'jquery-match-height';
import 'jquery-jpostal-ja';
import 'hiraku/js/jquery-hiraku.min';
import 'webp-in-css/polyfill';
import 'jquery-autosize';
import 'jquery-ui-dist/jquery-ui';
import 'jscroll/dist/jquery.jscroll.min';
import 'jquery-paginate/jquery-paginate.min';
import 'focus-visible/dist/focus-visible.min.js';
require('readmore-js');


// originals
import './common/device';
import './common/drawer';
import './common/flash';
import './common/form';
import './common/ios';
import './common/tippy';
import './common/size';
import './common/message';
import './common/password';
import './common/footer-fixed';
import './common/jpostal';
import './common/data-href';
import './common/modernizr-custom';
import './common/perfect-scrollbar';
import './common/smooth-scroll';
import './common/flatpickr';

// companies
import './companies/detail';

// elements
import './elements/parts/footer';
import './elements/parts/header';
import './elements/parts/modal';
import './elements/parts/loading';
import './elements/parts/animation';

// columns
import './columns/detail';

// mypage
import './mypage/company/reserve/index';
import './mypage/company/new';
import './mypage/company/form';
import './mypage/company/use-request';
import './mypage/company/reserve-able';
import './mypage/company/temporary-close';
import './mypage/company/phone-client/index'; // on
import './mypage/company/recruit';
import './mypage/company/vehicle-info/index';
import './mypage/jobseeker/profile';
import './mypage/reserve/index';
import './mypage/reserve/edit';
import './mypage/fileupload';
import './mypage/message/index';
import './mypage/quote/edit';
import './mypage/index';
import './mypage/password-change';

// quote
import './quote/quote-answer'; // on

import './searchs/index';
import './searchs/map';

import './home';

import './pages/price';